export const classes = {
  activeSlide: {
    height: 'auto',
    overflow: 'visible',
  },
  fullWitdh: {
    width: '100%',
  },
  inactiveSlide: {
    height: 0,
    overflow: 'hidden',
  },
}
